import header from "./hotelanlage-wird-gescannt.webp";
import section1 from "./grundriss-hotel-auf-zettel.png";
import section2 from "./hotel-zimmer-klingel.jpg";
import section3 from "./hotelanlage.png";
import section4 from "./hotel-grundriss-auf-papier.png";

export { header, section1, section2, section3, section4 };
